import { render, staticRenderFns } from "./AddUpdateUser.vue?vue&type=template&id=6d81705c&scoped=true"
import script from "./AddUpdateUser.vue?vue&type=script&lang=js"
export * from "./AddUpdateUser.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateUser.vue?vue&type=style&index=0&id=6d81705c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d81705c",
  null
  
)

export default component.exports